import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-committee',
  standalone: false,
  templateUrl: './committee.component.html',
  styleUrl: './committee.component.scss'
})
export class CommitteeComponent implements OnInit, OnDestroy {
committeeName: any[] = [];
  committeeForm: FormGroup;
  assignmentForm: FormGroup;
  assignmentUpForm: FormGroup;
  hoveredIndex: number | null = null;
  memberCols = [
    // { field: 'committee.name', header: 'Committee Name', filterType: 'text' },
    { field: 'user.first_name', header: 'User Name', filterType: 'text' },
    { field: 'user.email', header: 'Email', filterType: 'text' },
    { field: 'role', header: 'Role', filterType: 'text' },

  ];
  members: any
  committeemember: any
  userList: any
  selectedUser: any;
  currentPage: number = 1;
  itemsPerPage: number = 9;
  showAddDialog: boolean = false;
  selectedCommittee: any;
  viewdetails: boolean = false;
  showDeleteDialog: boolean = false;
  filteredRecentProposals: any
  private subscriptions = new Subscription();
  constructor(private api: ApiService, private fb: FormBuilder, private messageService: MessageService, private permissionService: PermissionsService) { }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
    this.getCommittee()
    this.committeeForm = this.fb.group({
      committeeName: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]]
    });
    this.assignmentForm = this.fb.group({
      user: [null, Validators.required],
      role: ['', Validators.required],
      // committee: [null, Validators.required]
    });
    this.assignmentUpForm = this.fb.group({
      user: [null, Validators.required],
      role: ['', Validators.required],
      // committee: [null, Validators.required]
    });
  }
  getColorCode(index: number): string {
    const colors = ['#4e73df', '#1cc88a', '#f6c23e', '#e74a3b', '#36b9cc', '#e94568ff'];
    return colors[index % colors.length];
  }

  borderPrefix(index: number): string {
    const borders = [
      'border-left-primary',
      'border-left-success',
      'border-left-warning',
      'border-left-danger',
      'border-left-info'
    ];
    return borders[index % borders.length];
  }

  textPrefix(index: number): string {
    const texts = [
      'text-primary',
      'text-success',
      'text-warning',
      'text-danger',
      'text-info'
    ];
    return texts[index % texts.length];
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  searchProposalQuery: string = '';
  searchProposals(event: any) {
    this.searchProposalQuery = event.target.value.toLowerCase();
    this.committeeName = this.filteredRecentProposals.filter(proposal =>
      proposal.name.toLowerCase().includes(this.searchProposalQuery)
    );
    this.currentPage = 1; // Reset to first page when searching
  }
  clearSearch() {
    this.searchProposalQuery = '';
    this.searchProposals({ target: { value: '' } }); // Resets search
  }
  getCommittee() {
    const sub = this.api.getAPI(`/master/committee/`).subscribe((res: any) => {
      this.committeeName = res.data;
      this.filteredRecentProposals = [...this.committeeName]
    });
    this.subscriptions.add(sub);
  }

  onCommitteeSubmit() {
    if (this.committeeForm.valid) {
      let payload = {
        name: this.committeeForm.get('committeeName').value

      }
      if (this.selectedCommittee) {
        const sub = this.api.putAPI(`/master/committee/${this.selectedCommittee.id}/`, payload).subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Committee updated successfully'
            });
            this.showAddDialog = false;
            this.getCommittee();
            this.committeeForm.reset();
          },
          error: (err) => {
            console.error('Error while saving mapping:', err);

            // this.messageService.add({
            //   severity: 'error',
            //   summary: 'Error',
            //   detail: 'Failed to save mapping. Please try again.'
            // });
          }
        });
        this.subscriptions.add(sub);
      } else {
        const sub = this.api.postAPI('/master/committee/', payload).subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Committee added successfully'
            });
            this.showAddDialog = false;
            this.getCommittee();
            this.committeeForm.reset();
            // this.activeIndex = 1; // Move to next step
          },
          error: (err) => {
            console.error('Error while saving mapping:', err);

            // this.messageService.add({
            //   severity: 'error',
            //   summary: 'Error',
            //   detail: 'Failed to save mapping. Please try again.'
            // });
          }
        });
        this.subscriptions.add(sub);
      }

    }
  }
  addCommittee() {
    this.committeeForm.reset()
    this.showAddDialog = true;
    this.selectedCommittee = null
  }
  updateCommitte(data: any) {
    this.showAddDialog = true;
    this.selectedCommittee = data
    setTimeout(() => {
      this.committeeForm.patchValue({
        committeeName: this.selectedCommittee.name
      });
    }, 0);
  }
  deleteCommittee(data: any) {
    const sub = this.api.deleteAPI(`/master/committee/${data.id}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Committee deleted successfully'
        });
        this.showAddDialog = false;
        this.getCommittee();
      },
      error: (err) => {
        console.error('Error while saving mapping:', err);

        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to save mapping. Please try again.'
        // });
      }
    });
    this.subscriptions.add(sub);
  }
  ViewDetails(data: any) {
    this.viewdetails = true;
    this.getUserList();
    this.selectedCommittee = data
    this.getCommitteeMembers()
  }
  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.results?.data || res.data;
    })
    this.subscriptions.add(sub);
  }

  editMemberDialog: boolean = false;

  totalRecords: number = 0;
  getCommitteeMembers(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/committee/member/?committee=${this.selectedCommittee.id}&page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      this.members = res.results;
      this.totalRecords = this.members.length
    });
    this.subscriptions.add(sub);
  }
  onAssignmentSubmit() {
    if (this.assignmentForm.valid) {
      let payload = {
        committee_id: this.selectedCommittee.id,
        user_id: this.assignmentForm.get('user').value.id,
        role: this.assignmentForm.get('role').value

      }
      const sub = this.api.postAPI('/master/committee/member/', payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Committee member added successfully'
          });
          this.getCommitteeMembers();
          this.assignmentForm.reset();
          // this.activeIndex = 1; // Move to next step
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: 'Failed to save mapping. Please try again.'
          // });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  updateCommittemeber(data: any) {
    this.editMemberDialog = true;
    this.selectedUser = data;
    const matchedUser = this.userList.find(u => u.id === data.user.id);
    const matchedCommittee = this.committeeName.find(c => c.id === data.committee.id);

    if (!matchedUser || !matchedCommittee) {
      console.warn("User or Committee not found in dropdown lists.");
    }

    this.assignmentUpForm.patchValue({
      user: matchedUser,
      role: data.role,
      committee: matchedCommittee
    });
  }
  onAssignmentUpdateSubmit() {
    if (this.assignmentUpForm.valid) {
      let payload = {
        committee_id: this.selectedUser.committee.id,
        user_id: this.assignmentUpForm.get('user')?.value.id,
        role: this.assignmentUpForm.get('role')?.value

      }
      //  console.log(payload , this.assignmentUpForm.get('committee').value.id)
      const sub = this.api.putAPI(`/master/committee/member/${this.selectedUser.id}/`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Committee member updated successfully'
          });
          this.getCommitteeMembers();
          this.assignmentUpForm.reset();
          this.editMemberDialog = false;
          // this.activeIndex = 1; // Move to next step
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: 'Failed to save mapping. Please try again.'
          // });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  showDeletePopup(data: any) {
    this.selectedUser = data
    this.showDeleteDialog = true;

  }
  deleteMember() {
    const sub = this.api.deleteAPI(`/master/committee/member/${this.selectedUser.id}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Member Deleted Successfully',
        });
        this.getCommitteeMembers()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/committee', 'Edit') ||
      this.permissionService.hasPrivilege('/master/committee', 'Delete') ||
      this.permissionService.hasPrivilege('/master/committee', 'View');
  }
}
